import React from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import styles from './picker_search_error.scss'

const PickerSearchError = ({title, message, hint}) => (
	<div styleName='wrapper'>
		<p styleName='title'>{title}</p>
		<p styleName='subtitle'>{message}</p>
		{hint && <p styleName='hint'>{hint}</p>}
	</div>
)

PickerSearchError.defaultProps = {
	title: '',
	message: '',
	hint: '',
}

PickerSearchError.propTypes = {
	title: PropTypes.string,
	message: PropTypes.string,
	hint: PropTypes.string,
}

export default CSSModules(PickerSearchError, styles, {allowMultiple: true})
